import React from 'react'
import './Alumni.css'

import Slider from 'react-slick'
import AlumniCard from './AlumniCard'

import deepinder from '../../assets/alumni/deepinder-goyal.jpg'
import jayant from '../../assets/alumni/jayant-sinha.jpeg'
import raghuram from '../../assets/alumni/raghuram-rajan.jpg'
import padmasree from '../../assets/alumni/padmasree-warrior.png'
import chetan from '../../assets/alumni/chetan-bhagat.jpg'
import sachin from '../../assets/alumni/sachin-bansal.jpg'
import binny from '../../assets/alumni/binny-bansal.jpg'
import kiran from '../../assets/alumni/kiran-bedi.png'
import soumitra from '../../assets/alumni/soumitra-dutta.jpg'
import vinod from '../../assets/alumni/vinod-khosla.jpg'


import bill_gates_img from '../../assets/speakers/bill_gates.png'
import anthony_albanese_img from '../../assets/speakers/anthony_albanese.png'
import werner_vogels_img from '../../assets/speakers/werner_vogels.png'
import cameron_adams_img from '../../assets/speakers/cameron_adams.png'
import marten_meldal_img from '../../assets/speakers/marten_meldal.png'
import amandeep_singh_gill_img from '../../assets/speakers/amandeep_singh_gill.png'
import soumya_swaminathan_img from '../../assets/speakers/soumya_swaminathan.png'
import jaya_jagadish_img from '../../assets/speakers/jaya_jagadish.jpg'
import vinod_khosla_img from '../../assets/speakers/vinod_khosla.jpg'
import abraham_stroock_img from '../../assets/speakers/abraham_stroock.jpg'
import jake_sullivan_img from '../../assets/speakers/jake_sullivan.png'


export default function Alumni() {

    const settings =  {
        dots: false,
        infinite: true,
        speed: 750,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: true,
        centerMode: true,

        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    }

    return (
        <div className="distinguished_alumni">
            <h3>OUR GUEST SPEAKERS</h3>
            <div className="alumni_carousel">
                <Slider {...settings}>
                    <div>
                        <AlumniCard name="Mr. Bill Gates" image={bill_gates_img} about="Co-Founder, Microsoft" />
                    </div>
                    <div>
                        <AlumniCard name="Mr. Anthony Albanese" image={anthony_albanese_img} about="Prime Minister of Australia" />
                    </div>
                    <div>
                        <AlumniCard name="Mr. Werner Vogels" image={werner_vogels_img} about="Chief technology officer of Amazon" />
                    </div>
                    <div>
                        <AlumniCard name="Mr. Cameron Adams" image={cameron_adams_img} about="Co-Founder, Canva" />
                    </div>
                    <div>
                        <AlumniCard name="Mr. Marten Meldal" image={marten_meldal_img} about="A Pioneer in the field of Click Chemistry and the 2022 Nobel Prize Winner in Chemistry" />
                    </div>
                    <div>
                        <AlumniCard name="Mr. Amandeep Singh Gill" image={amandeep_singh_gill_img} about="UN Under-Secretary-General for Digital & Emerging Technologies" />
                    </div>
                    <div>
                        <AlumniCard name="Dr. Soumya Swaminathan" image={soumya_swaminathan_img} about="Chairperson of the M S Swaminathan Research Foundation and WHO's first Chief Scientist" />
                    </div>
                    <div>
                        <AlumniCard name="Ms. Jaya Jagadish" image={jaya_jagadish_img} about="Country Head & SVP, Silicon Design Engineering at AMD India Private Limited" />
                    </div>
                    <div>
                        <AlumniCard name="Mr. Vinod Khosla" image={vinod_khosla_img} about="Founder of Khosla Ventures, an entrepreneur, investor, and technologist dedicated to building impactful technology-based disruptive companies" />
                    </div>
                    <div>
                        <AlumniCard name="Mr. Jake Sullivan" image={jake_sullivan_img} about="U.S. National Security Advisor" />
                    </div>
                </Slider>
            </div>
        </div>
    )
}
